/**
 * Maps Indicator collection properties
 * @since Ago, 2018
 */
export class Indicator {
  /** Unique mongo document identifier of the Indicator (autogenerated by db)*/
  public _id: string;
  /** Unique string identifier of the Indicator (filled by user) */
  public indicator: string;
  /** Topic of the indicator (for classification purposes) */
  public topic: string;
  /** Name of the indicator */
  public name: string;
  /** Minor frequency the indicator was generated (monthly, yearly) */
  public minorFrequency: string;
  /** Minor geography the indicator was obtained (minicipalities, states, national) */
  public minorGeography: string;
  /** Kind of indicator, every indicator already registered is kind 'fila' meaning that has only one column for values
   * @default 'fila'
  */
  public kind: string;
  /** Kind of answers. By definition, indicators are continous data. (kindAnswer = 2)
   * @default 2
  */
  public kindAnswer: number;
  /** Source of the indicator's data */
  public source: string;
  /** Name of the column that contains the values, and should be collapsed by
   * @default 'value'
   */
  public collapseBy: string;
  /** Name of the column that contains a relative percentage that should be used as denominator  */
  public percentageCol: string;
  /** Constant to be used for calculations of percentage
   * @default 100
   */
  public percentageConst: number;
  /** Units' name, what are you measuring? Pesos, kilos, people */
  public unitsName: string;
  /** If rate or percentage are calculated by a relative external value, should be specified */
  public relativeTo: string;
  /** Indicator document is active or nor */
  public active: boolean;
  /** Column that should be used as denominator for a rate calculation. Eg: 'population' */
  public rateCol: string;
  /** Constant that should be used as reference for rate calculation Eg. 10000 */
  public rateConst: number;
  /** Total can be calculated for this indicator (defined as a sum of values) */
  public total: boolean;
  /** Percentage can be calculated for this indicator (based on total of values, or a relative column) */
  public percentage: boolean;
  /** Average values can be calculated for this indicator */
  public average: boolean;
  /** A rate can be calculated for this indicator */
  public rate: boolean;
  /** This indicator is treated like an index, and no calculations should be made */
  public index: boolean;
  /** Name of the index to show in display (Eg. ir a Percentage already calculated) */
  public indexName: string;
  /** Options to use in axes, group by options, and filters. Depend on deaggregation levels of the indicator */
  public fieldOptions: {name: string, slug: string, type: string, options: {slug: any, name: any}[]}[];

  /** Inits indicator instance using an object's properties */
  constructor(obj: Object) {
    this._id = obj['_id'];
    this.topic = obj['topic'];
    this.name = obj['name'];
    this.minorFrequency = obj['minorFrequency'];
    this.minorGeography = obj['minorGeography'];
    this.indicator = obj['indicator'];
    this.kind = obj['kind'];
    this.kindAnswer = obj['kindAnswer'];
    this.source = obj['source'];
    this.collapseBy = obj['collapseBy'];
    this.percentageCol = obj['percentageCol'];
    this.rateCol = obj['rateCol'];
    this.rateConst = obj['rateConst'];
    this.unitsName = obj['unitsName'];
    this.relativeTo = obj['relativeTo'];
    this.total = obj['total'];
    this.percentage = obj['percentage'];
    this.rate = obj['rate'];
    this.average = obj['average'];
    this.index = obj['index'];
    this.indexName = obj['index_name'];
    this.active = obj['active'];
    this.fieldOptions = obj['fieldOptions'];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/indicator.class.ts